import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { ItemDisplay, LeverageCard, LeverageCardRow } from './leverageComponents';
import { SuggestedLeverageCardProps } from '../leverageStep';

export const StabilizedBridgeSuggestedLeverageCard = ({
  suggestedLoanQuote,
  quoteTypeStore,
}: SuggestedLeverageCardProps) => {
  const {
    totalLoanAmount = 0,
    totalPurchasePrice = 0,
    totalMarketValue = 0,
    loanToCost = 0,
    calculatedLtv = 0,
  } = suggestedLoanQuote;

  const showOnlyLTVValues = quoteTypeStore.showOnlyLTVValues;
  const costBasisLabel = quoteTypeStore.getCostBasisLabel();

  return (
    <LeverageCard
      title="Suggested Insta-Quote"
      subtitle="Calculated during loan submission. For reference only."
      disabled={false}
      instaQuote={true}
      LeverageMatrixCard={null}
      quoteTypeStore={null}
      disabledWarning={false}
    >
      {!showOnlyLTVValues && (
        <LeverageCardRow
          dividend={
            <ItemDisplay
              label="Loan Amount"
              value={formatCurrency(totalLoanAmount)}
            />
          }
          divisor={
            <ItemDisplay
              label={costBasisLabel}
              value={formatCurrency(totalPurchasePrice)}
            />
          }
          result={
            <ItemDisplay
              label="Loan to Cost"
              value={formatPercentage(loanToCost)}
            />
          }
        />
      )}
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Total Loan Amount"
            value={formatCurrency(totalLoanAmount)}
          />
        }
        divisor={
          <ItemDisplay
            label="Market Value"
            value={formatCurrency(totalMarketValue)}
          />
        }
        result={
          <ItemDisplay
            label={'Loan to Value'}
            value={formatPercentage(showOnlyLTVValues ? loanToCost : calculatedLtv)}
          />
        }
      />
    </LeverageCard>
  );
};
